import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 38;

export const migration_37_38:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            const workbook:any = Object.values(designState.spreadsheets.workbooks)[0];

            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {id, componentDesc: {_baseEventProps}} = boxSnapshot;

                        if( _baseEventProps )
                        {
                            Object.values(_baseEventProps).forEach((baseEventProp:any) =>
                            {
                                if( baseEventProp.bindingId && designState.bindings )
                                {
                                    const binding:any = Object.values(designState.bindings).find(
                                        (binding:any) => binding.id === baseEventProp.bindingId
                                    );

                                    if( binding && binding.boxId !== id )
                                    {
                                        const range:any = Object.values(workbook.runtime.namedRanges).find(
                                            (namedRange:any) => namedRange.id === binding.rangeId
                                        );

                                        const newRange = !range.name
                                            ? {
                                                id: IdUtil.newGUID(),
                                                name: null,
                                                sheetId: range.sheetId,
                                                location: range.location,
                                                framePath: range.framePath,
                                                rowCount: range.rowCount,
                                                colCount: range.colCount
                                            }
                                            : null;

                                        const newBinding = {
                                            id: IdUtil.newGUID(),
                                            sheetId: binding.sheetId,
                                            pageId: binding.pageId,
                                            boxId: id,
                                            propId: baseEventProp.id,
                                            rangeId: newRange ? newRange.id : binding.rangeId,
                                            repeaterFixation: binding.repeaterFixation,
                                            isPropBinding: binding.isPropBinding,
                                            propPath: binding.propPath,
                                            direction: binding.direction,
                                            useFormat: binding.useFormat
                                        } as any;

                                        baseEventProp.bindingId = newBinding.id;

                                        if( newRange )
                                            workbook.runtime.namedRanges[newRange.id] = newRange;

                                        designState.bindings[newBinding.id] = newBinding;
                                    }
                                    else if( binding && binding.boxId === id )
                                        binding.propId = baseEventProp.id;
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
